import { render } from "./TeacherAnalytics.vue?vue&type=template&id=1297a686&scoped=true"
import script from "./TeacherAnalytics.vue?vue&type=script&lang=js"
export * from "./TeacherAnalytics.vue?vue&type=script&lang=js"

import "./TeacherAnalytics.vue?vue&type=style&index=0&id=1297a686&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1297a686"]])

export default __exports__